import View from '../View';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const config = createIntegratedAtom({
  displayName: 'Div Block',
  showEmpty: true,
  constraints: {
    ancestors: [{is: 'CommerceCheckoutOrderItem', rule: 'ExactlyOne'}],
  },
  style: {
    base: {
      main: {
        noPseudo: {
          marginLeft: px(16),
          marginRight: px(16),
          flexGrow: 1,
        },
      },
    },
  },
  render: View,
  fields: {children: TListOfElement},
});

export default config;
